// ============================================================
//  src/components/ui/LoadingScreen.jsx
// ============================================================
import React from 'react';
import { Vote } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 bg-primary-800 rounded-2xl flex items-center justify-center animate-pulse-slow">
          <Vote size={32} className="text-white" />
        </div>
        <div className="flex gap-1">
          {[0,1,2].map(i => (
            <div
              key={i}
              className="w-2 h-2 bg-primary-800 rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
